import React from 'react';
import { IconType } from 'react-icons';

interface IconWrapperProps {
  icon: IconType;
  size?: number;
  className?: string;
}

export const IconWrapper = ({ icon: Icon, size, className }: IconWrapperProps) => {
  return <Icon size={size} className={className} />;
};

export default IconWrapper; 